import React, {useState, useEffect} from 'react';

const Button = ({btnName,btnId,btnWidth,btnClass,btnParentClassName,disabled,clickEventHandler,customBtnStyle,btnParentStyle}) => {
  
  const [isStyleTagPresent, setIsStyleTagPresent] = useState(false); //Added for stylus tool text-spacing change
  //Added for stylus tool
  useEffect(() => {
    const checkStyleTag = () => {
      const styleTag = document.querySelector('style.stylus');
      setIsStyleTagPresent(!!styleTag); 
    };
    checkStyleTag();
    const intervalId = setInterval(checkStyleTag, 500); // Check every 500ms
    return () => clearInterval(intervalId);  // Clean up interval when component unmounts
  }, []);
  
  
  const finalWidth = isStyleTagPresent && btnName === 'Skip Walk-Thru' ? 155 : btnWidth;
  const btnStyle={
      color:"#fff",
      // backgroundColor:"rgb(214 84 158)",
      backgroundColor:"#B2347B",
      padding:"8px 12px",
      borderRadius:"30px",
      border: "1px solid transparent",
      margin:0,
      width:finalWidth+"px"
  }
  return (
      <div className={`container ${btnParentClassName?btnParentClassName:""}`} style={btnParentStyle ? btnParentStyle : {}}>
        <button type="button" role="button" disabled={disabled} id={btnId} style={customBtnStyle ? {...btnStyle,...customBtnStyle}:btnStyle} className={`ui button ${btnClass?btnClass:""}`} onClick={clickEventHandler}>{btnName}</button>
      </div>
  );
}

export default Button